import React from "react";
import { TooltipProps } from "recharts";

type CustomTooltipProps = TooltipProps<number, string> & {
  labelName: string;
};

export const FrameMetricTooltip: React.FC<CustomTooltipProps> = ({
  active,
  payload,
  label,
  labelName,
}) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          background: "#222",
          border: "1px solid #444",
          color: "#fff",
          padding: 10,
          borderRadius: 6,
        }}
      >
        <div>Frame #{label}</div>
        <div>
          {labelName}:{" "}
          <span style={{ color: "#4fc3f7", fontWeight: 600 }}>
            {typeof payload[0].value === "number"
              ? Number.isInteger(payload[0].value)
                ? payload[0].value
                : payload[0].value.toFixed(2)
              : payload[0].value}
          </span>
        </div>
      </div>
    );
  }
  return null;
};
